import { Certificate } from 'app/library/certificate/models/certificate.model';
import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';

export class SetCertificate {
    static readonly type = '[Certificate] SetCertificate';

    constructor(public payload: Certificate) {}
}

export class UnsetCertificate {
    static readonly type = '[Certificate] UnsetCertificate';
}

export class FetchCertificate {
    static readonly type = '[Certificate] FetchCertificate';

    constructor(public payload: string) {}
}

export class FetchCertificateSuccess {
    static readonly type = '[Certificate] FetchCertificateSuccess';

    constructor(public payload: Certificate) {}
}

export class FetchCertificateFailure {
    static readonly type = '[Certificate] FetchCertificateFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class AddCertificates {
    static readonly type = '[Certificate] AddCertificates';

    constructor(public payload: Certificate[]) {}
}

export class CreateCertificate {
    static readonly type = '[Certificate] CreateCertificate';

    constructor(public payload: Certificate) {}
}

export class CreateCertificateSuccess {
    static readonly type = '[Certificate] CreateCertificateSuccess';

    constructor(public payload: Certificate) {}
}

export class CreateCertificateFailure {
    static readonly type = '[Certificate] CreateCertificateFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdateCertificate {
    static readonly type = '[Certificate] UpdateCertificate';

    constructor(public payload: Certificate) {}
}

export class UpdateCertificateSuccess {
    static readonly type = '[Certificate] UpdateCertificateSuccess';

    constructor(public payload: Certificate) {}
}

export class UpdateCertificateFailure {
    static readonly type = '[Certificate] UpdateCertificateFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class DeleteCertificate {
    static readonly type = '[Certificate] DeleteCertificate';

    constructor(public payload: string) {}
}

export class DeleteCertificateSuccess {
    static readonly type = '[Certificate] DeleteCertificateSuccess';

    constructor(public payload: string) {}
}

export class DeleteCertificateFailure {
    static readonly type = '[Certificate] DeleteCertificateFailure';

    constructor(public payload: string) {}
}

export class SetCertificates {
    static readonly type = '[Certificate] SetCertificates';

    constructor(public payload: Certificate[]) {}
}

export class FetchCertificates {
    static readonly type = '[Certificate] FetchCertificates';
}

export class FetchCertificatesSuccess {
    static readonly type = '[Certificate] FetchCertificatesSuccess';
}

export class FetchCertificatesFailure {
    static readonly type = '[Certificate] FetchCertificatesFailure';
}

export class UnsetCertificateAll {
    static readonly type = '[Certificate] UnsetCertificateAll';
}

export class UploadCertificateTemplate {
    static readonly type = '[Certificate] UploadCertificateTemplate';

    constructor(public file: File) {}
}

export class UploadCertificateTemplateSuccess {
    static readonly type = '[Certificate] UploadCertificateTemplateSuccess';

    constructor(public payload: Certificate) {}
}

export class UploadCertificateTemplateFailure {
    static readonly type = '[Certificate] UploadCertificateTemplateFailure';
}
